import React, { useEffect, useRef } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import { motion } from 'framer-motion';
import 'keen-slider/keen-slider.min.css';

const headlinesData = [
    {
        id: 1,
        title: "Using AI to fast -track climate goal",
        desc: "Flexible work arrangements can be formal (which may be part of your contract) or informal (which you'll arrange with your lead)."
    },
    {
        id: 2,
        title: "Sustainability Magazine",
        desc: "Flexible work arrangements can be formal (which may be part of your contract) or informal (which you'll arrange with your lead)."
    },
    {
        id: 3,
        title: "Mobikode joins 1.5c supply chain leaders",
        desc: "Flexible work arrangements can be formal (which may be part of your contract) or informal (which you'll arrange with your lead)."
    },
    {
        id: 4,
        title: "Global Eco Innovation Summit",
        desc: "Flexible work arrangements can be formal (which may be part of your contract) or informal (which you'll arrange with your lead)."
    }
];

const MakingHeadlines = () => {
    const timerRef = useRef(null);

    const [sliderRef, instanceRef] = useKeenSlider({
        loop: true,
        rtl: false,
        slides: {
            perView: 1,
            spacing: 16,
        },
        breakpoints: {
            '(min-width: 640px)': {
                slides: { perView: 2, spacing: 20 },
            },
            '(min-width: 1024px)': {
                slides: { perView: 3, spacing: 24 },
            },
        },
        created(s) {
            s.container.addEventListener("mouseover", () => {
                clearTimeout(timerRef.current);
            });
            s.container.addEventListener("mouseout", () => {
                startAutoplay(s);
            });
            startAutoplay(s);
        },
        destroyed() {
            clearTimeout(timerRef.current);
        }
    });

    const startAutoplay = (sliderInstance) => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            sliderInstance.next();
            startAutoplay(sliderInstance);
        }, 4000);
    };

    return (
        <section className="w-full bg-[#FFFFFF] pb-16 lg:pb-24 overflow-hidden select-none text-left relative z-50">
            <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

                <div className="w-full mb-12 lg:mb-16">
                    <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] tracking-tight font-sora">
                        Making Headlines
                    </h2>
                </div>

                <div ref={sliderRef} className="keen-slider">
                    {headlinesData.map((item) => (
                        <div key={item.id} className="keen-slider__slide">
                            <div className="w-full h-[320px] bg-white border rounded-none p-6 sm:p-8 flex flex-col justify-between relative group cursor-pointer transition-all duration-300">

                                <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-[#01386A] z-10" />
                                <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#ED6800] z-20 transition-all duration-500 ease-out group-hover:w-full" />

                                <div className="w-full flex flex-col items-start relative z-30">
                                    <h3 className="text-[#01386A] font-[600] font-sora text-[16px] lg:text-[20px] tracking-tight leading-snug mb-4">
                                        {item.title}
                                    </h3>
                                </div>

                                <div className="w-full mt-auto relative z-30">
                                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik leading-relaxed font-[500]">
                                        {item.desc}
                                    </p>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>

                {/* Navigation Arrow Icons */}
                <div className="flex items-center gap-3 mt-8">
                    <button
                        onClick={() => instanceRef.current?.prev()}
                        className="w-10 h-10 rounded-full border border-[#EA580C] flex items-center justify-center text-[#EA580C] bg-white hover:bg-[#EA580C] hover:text-white transition-all duration-300 active:scale-95"
                    >
                        <span className="font-mono text-[18px] font-bold">&larr;</span>
                    </button>
                    <button
                        onClick={() => instanceRef.current?.next()}
                        className="w-10 h-10 rounded-full border border-[#EA580C] flex items-center justify-center text-[#EA580C] bg-white hover:bg-[#EA580C] hover:text-white transition-all duration-300 active:scale-95"
                    >
                        <span className="font-mono text-[18px] font-bold">&rarr;</span>
                    </button>
                </div>

            </div>
        </section>
    );
};

export default MakingHeadlines;